import React from 'react'
import styled from 'styled-components'

ExpiredWarning = (props)->
	<Wrapper>
		<TextContent>
			<Title>{'Deactivated Digital Card'}</Title>
			<Body>{'This card has been deactivated because the 7-day free trial for this order has expired. If you are the owner of this card, please follow the instructions in your email to reactivate your card.'}</Body>
		</TextContent>
	</Wrapper>


Wrapper = styled.div"""
	position: fixed
	top: 0
	left: 0
	width: 100vw
	height: 100vh
	background-color: #f1f5f7
"""

TextContent = styled.div"""
	box-sizing: border-box
	position: absolute
	left: 0
	top: 50%
	transform: translateY(-50%);
	width: 100%
	padding: 0 20px;
	font-family: din
	text-align: center
"""

Title = styled.div"""
	font-size: 24px
"""

Body = styled.div"""
	max-width: 400
	margin: 15px auto 0;
	font-size: 14px
"""

export default ExpiredWarning